import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import {
  getMentorAndMenteeMailVariableData,
  getMentorAndMenteeMailVariables,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerContactReminderMentor() {
  return defineMailTemplate(MailTemplateType.CONTACT_REMINDER_MENTOR, {
    getMailData: getMentorAndMenteeMailVariableData,
    defaultTemplate: {
      subject: `Mentoring-Programm: Bitte nehmen Sie Kontakt auf`,
      content: `<p>Hallo&nbsp;{{mentor.salutation}} {{mentor.firstName}} {{mentor.lastName}},<br></p>
        <p> Ihr Mentee {{mentee.firstName}}&nbsp;{{mentee.lastName}}&nbsp;hat uns kontaktiert, weil Sie sich nach unserer Bestätigungs-Mail, dass wir Sie beide erfolgreich gematcht haben, noch nicht gemeldet haben. </p>
        <p> Hatten Sie vielleicht keine Zeit oder gab es technische oder sonstige Schwierigkeiten Ihren Mentee zu kontaktieren? </p>
        <p> Bitte geben Sie uns eine kurze Rückmeldung und schreiben {{mentee.firstName}} {{mentee.lastName}} unter {{mentee.email}} in den nächsten 2 Tagen. Vielen Dank.&nbsp;</p>
        <p> Falls Sie sich in den nächsten 2 Tagen nicht bei {{mentee.firstName}} {{mentee.lastName}} und uns melden, gehen wir davon aus, dass Sie dieses Semester nicht am Mentoring-Programm teilnehmen und wir eine:n neue:n Mentor:in für {{mentee.firstName}} {{mentee.lastName}} finden. </p>
        <p> Viele Grüße, </p>
        <p> Ihr Mentoring-Team</p>`,
      footer: '',
    },
    variables: getMentorAndMenteeMailVariables(),
    attachments: [],
    displayName: 'Kontakterinnerung: Mentor',
    editorHint: () =>
      'Diese Mail kann an den Mentor versendet werden, wenn er sich nach einem Match nicht zurückmeldet.',
  });
}
